import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from 'src/app/services/http.service';
import { LanguageService } from 'src/app/services/language.service';
import { SettingsService } from 'src/app/services/settings.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ListFields } from '../../listfields';
import { BikeComponent, BikeComponentVariant } from '../component';
import { forkJoin } from 'rxjs';
import { MultipleSearchPropertyPipe } from 'src/app/pipes/multiple-search-property.pipe';
import { AccountService } from 'src/app/services/account.service';
import { DataParserService } from 'src/app/services/data-parser.service';

@Component({
  selector: 'app-component-list',
  templateUrl: './component-list.component.html',
  styleUrls: ['./component-list.component.scss'],
  standalone: false
})
export class ComponentListComponent implements OnInit {

  /** Define field list for sorting and grouping */
  public componentFields: ListFields[] = [
    { Id: 0, FieldName: "Component", Uppercase: false, DisplayName: this.languageService.languageJSON.ComponentList_ComponentType, SearchBy: true, GroupBy: true },
    { Id: 1, FieldName: "ComponentName", Uppercase: false, DisplayName: this.languageService.languageJSON.ComponentDetails_ComponentName, SearchBy: true, GroupBy: true },
    { Id: 2, FieldName: "ComponentIdentifier", Uppercase: false, DisplayName: this.languageService.languageJSON.ComponentDetails_ComponentIdentifier, SearchBy: true, GroupBy: true },
    { Id: 3, FieldName: "OEMName", Uppercase: false, DisplayName: this.languageService.languageJSON.ComponentDetails_OEMName, SearchBy: true, GroupBy: true }
  ];

  /** List view of the bike components */
  public componentList: BikeComponent[] = [];
  public searchByList: any = {};
  public loading: boolean = true;
  public componentClassOptionsList: { id: number, name: string }[] = [];
  public oeOptionsList: { id: number, name: string }[] = [];
  public order: string = this.componentFields[0].FieldName;
  public reverse: boolean = false;
  public caseInsensitive: boolean = true;
  public page: number = 1;
  public totalItems: number = 0;
  public itemsPerPage: number = this.settingsService.getItemsPerPage();

  constructor(public languageService: LanguageService, private httpService: HttpService,
    private router: Router, private settingsService: SettingsService, private utilsService: UtilsService,
    private route: ActivatedRoute, private multipleSearchPropertyPipe: MultipleSearchPropertyPipe,
    private accountService: AccountService, private dataParserService: DataParserService) { }

  /** Initializing components, initializing options */
  ngOnInit(): void {
    forkJoin([this.httpService.getComponentClassOptionsList(),
      this.httpService.getOEOptionsList(1, 0),
      this.httpService.getComponentList()
    ]).subscribe((resp) => {
      this.componentClassOptionsList = resp[0];
      this.oeOptionsList = resp[1];
      if ((resp[2] as any).success) {
        this.componentList = this.dataParserService.initComponents(resp[2], this.oeOptionsList, this.componentClassOptionsList, true);
        this.totalItems = this.componentList.length;
      }

      this.loading = false;

      this.route.queryParams
        .subscribe(params => {
          if (params['name']) {
            this.searchByList = { ComponentName: params['name'] };
          }
        });
    });
  }

  /** Changing table ordering by selected field */
  setOrder(value: string, groupBy: boolean) {
    if (groupBy) {
      if (this.order === value) {
        this.reverse = !this.reverse;
      }

      this.order = value;
    }
  }

  /** Returns component class name by id */
  public getComponentClass(id: number): string {
    return this.componentClassOptionsList.find((el) => { return el.id == id })?.name as string;
  }

  /** Opens edit component page */
  public editComponent(bike: BikeComponent): void {
    this.router.navigate(['/edit-component'], { queryParams: { id: bike.Id } });
  }

  public getVariantTooltipText(variants: BikeComponentVariant[]): string{
    let variantText = "";
    variants.forEach((element, number, array) => {
      variantText += element.Name;
      if (number!= array.length-1){
        variantText += ", ";
      }
    });

    return variantText;
  }

  public hasAnySearchElement(): boolean {
    return Object.keys(this.searchByList).length != 0;
  }

  public getPaginationText(): string {
    return this.utilsService.getPaginationText(this.itemsPerPage, this.page, this.totalItems);
  }

  public onPageChangeEvent(event: number) {
    this.page = event;
  }

  public onSearchChanged(event: any) {
    this.searchByList = event;
    this.totalItems = this.multipleSearchPropertyPipe.transform(this.componentList, this.searchByList).length;
  }

  public hasComponentEditRole(): boolean {
    return this.accountService.hasComponentEditRole();
  }
}
